import { useEffect, useState, useRef } from "react";

const LazyImage = ({ src, alt, className = "lazy", width, height, style }) => {
    const imgRef = useRef(null);
    const [isVisible, setIsVisible] = useState(false);
    const [isLoaded, setIsLoaded] = useState(false);

    useEffect(() => {
        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        setIsVisible(true);
                        observer.unobserve(entry.target);
                    }
                });
            },
            { threshold: 0.1 }
        );

        if (imgRef.current) {
            observer.observe(imgRef.current);
        }

        return () => observer.disconnect();
    }, []);

    const handleLoad = () => {
        setIsLoaded(true);
    };

    return (
        <img
            ref={imgRef}
            src={isVisible ? src : ""}
            alt={alt}
            className={`${className} ${isLoaded ? "lazyShow" : ""}`}
            width={width}
            height={height}
            style={style}
            onLoad={handleLoad}
        />
    );
};

export default LazyImage;